import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1OrganizationPositionIDOCToArray, V1PositionIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class OrganizationPositionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.Organization-002";

        let qbe = btoa(JSON.stringify({
            "PlatformMessage": {
                "-idoc": "v1.Organization-002",
                "-id": uuidv4(),
                "Organization": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "Position": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))

        AxiosAdminAPI({
            method: "GET",
            url: "t6/v1/organizations",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1OrganizationPositionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminOrganization = {};

        adminOrganization["USID"] = this.getEnterpriseObject().getEnterpriseComponent("Organization").getAttributeValue("USID");
        adminOrganization["Position"] = {
            "USID": this.getAttributeValue("USID"),
            "Name": this.getAttributeValue("Name"),
            "OrganizationUSID": this.getEnterpriseObject().getEnterpriseComponent("Organization").getAttributeValue("USID"),
            "ParentUSID": this.getAttributeValue("ParentUSID"),
            "PrimaryAccountUserUSID": this.getAttributeValue("PrimaryAccountUserUSID"),
        }

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Organization-002";
        payload.PlatformMessage.Organization = adminOrganization;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/organizations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Organization-002",
                "idoc-response": "v1.Organization-002"
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1OrganizationPositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Position-001";
        payload.PlatformMessage.Position = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Position-001",
                "idoc-response": "v1.Position-001",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1PositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

}

export default OrganizationPositionEnterpriseComponent;